import * as actionTypes from "../actions/actionTypes";

const initialState = {
  value: 5,
  action: null,
  from: null,
};

export const counter = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INCREMENT:
      return {
        ...state,
        value: state.value + 1,
        action: "increment",
        from: action.from,
      };

    case actionTypes.DECREMENT:
      return {
        ...state,
        value: state.value - 1,
        action: "decrement",
        from: action.from,
      };

    default:
      return state;
  }
};

export default counter;
